import React from 'react';
import { SalesReturnListBase } from './SalesReturnListBase';
import { usePatientContext } from '../../../components/SubPatinetProvider';

/**
 * PatientSalesReturnList - Shows sales returns filtered by the selected patient.
 * Uses server-side pagination and hides the Patient column.
 * Shows HeaderProfile component.
 */
export const PatientSalesReturnList: React.FC = () => {
  const { patientId } = usePatientContext();

  return (
    <SalesReturnListBase
      patientId={patientId}
      showHeaderProfile={true}
    />
  );
};

export default PatientSalesReturnList;
